import { useState } from "react";
import { toast } from "sonner";
import { FileText, FileImage, FileSpreadsheet, Download, Trash2 } from "lucide-react";
import { ConfirmDelete } from "@/components/Bits";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";

const iconFor = (ct) => (ct?.startsWith("image/") ? FileImage : ct?.includes("sheet") || ct?.includes("excel") ? FileSpreadsheet : FileText);
const size = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

const download = async (d) => {
  try {
    const { data } = await api.get(`/documentos/${d.documento_id}/download`, { responseType: "blob" });
    const href = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = href;
    a.download = d.nome_arquivo || d.titulo;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 10000);
  } catch (e) { toast.error("Falha ao baixar"); }
};

export const DocumentoList = ({ items, onChange }) => {
  const { user } = useAuth();
  const [del, setDel] = useState(null);
  const remove = async () => {
    try { await api.delete(`/documentos/${del.documento_id}`); toast.success("Documento removido"); setDel(null); onChange(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="doc-list">
      {items.map((d) => {
        const I = iconFor(d.content_type);
        const where = [d.cliente_nome, d.fazenda_nome, d.equipamento_codigo].filter(Boolean).join(" › ");
        return (
          <div key={d.documento_id} className="bg-white rounded-2xl border border-[#E2DDD3] p-4 flex items-center gap-3" data-testid={`doc-item-${d.documento_id}`}>
            <span className="h-12 w-12 rounded-xl bg-[#F5E6E0] text-[#B05A40] flex items-center justify-center shrink-0"><I className="h-6 w-6" /></span>
            <div className="min-w-0 flex-1">
              <p className="font-semibold truncate">{d.titulo}</p>
              <p className="text-xs text-[#5C6B66] truncate"><b className="text-[#1E4D2B]">{d.tipo_label}</b> · {where}</p>
              <p className="text-xs text-[#5C6B66]">{fmtDate(d.created_at)} · {size(d.size)} · {d.uploaded_by_name}</p>
            </div>
            <button onClick={() => download(d)} aria-label="Baixar" data-testid={`doc-download-${d.documento_id}`}
              className="h-12 w-12 rounded-xl border border-[#E2DDD3] flex items-center justify-center hover:bg-[#E8F5E9] hover:border-[#1E4D2B] shrink-0"><Download className="h-5 w-5" /></button>
            {user.role === "admin" && (
              <button onClick={() => setDel(d)} aria-label="Excluir" data-testid={`doc-delete-${d.documento_id}`}
                className="h-12 w-12 rounded-xl border border-[#E2DDD3] flex items-center justify-center text-[#B05A40] hover:bg-[#C86D51]/10 shrink-0"><Trash2 className="h-5 w-5" /></button>
            )}
          </div>
        );
      })}
      <ConfirmDelete open={!!del} onOpenChange={(o) => !o && setDel(null)} title="Excluir documento?" description={del?.titulo} onConfirm={remove} />
    </div>
  );
};
